module.exports = __webpack_public_path__ + "img/t_dist.962ce20a.png";